<template>
  <!-- Modern Navbar -->
  <nav class="modern-nav navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl" id="navbarBlur" navbar-scroll="true">
      <div class="container-fluid py-2 px-3">
        <!-- Mobile Menu Button -->
        <button class="navbar-toggler mobile-only d-lg-none me-2" type="button" @click="toggleMobileMenu" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        
        <nav aria-label="breadcrumb" class="d-none d-md-block">
          <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
            <li class="breadcrumb-item text-sm"><a class="opacity-5 text-dark" href="javascript:;">Панель</a></li>
            <li class="breadcrumb-item text-sm text-dark active" aria-current="page">{{ msg }}</li>
          </ol>
          <h6 class="font-weight-bolder mb-0">{{ msg }}</h6>
        </nav>
        
        <!-- Mobile Title -->
        <h6 class="font-weight-bolder mb-0 mobile-only d-lg-none">{{ msg }}</h6>
        
        <!-- Right side elements - always visible -->
        <div class="ms-auto d-flex align-items-center order-lg-3">
          <!-- Push Notifications Toggle -->
          <button @click="togglePushNotifications()" class="modern-btn modern-btn-ghost mb-0 me-2 me-lg-3 theme-toggle" :class="{ 'push-enabled': pushEnabled }" :title="pushEnabled ? 'Уведомления включены' : 'Уведомления выключены'">
            <i :class="pushEnabled ? 'fas fa-bell' : 'fas fa-bell-slash'"></i>
          </button>
          
          <!-- Theme Toggle -->
          <button @click="toggleTheme()" class="modern-btn modern-btn-ghost mb-0 me-2 me-lg-3 theme-toggle" title="Переключить тему">
            <i :class="isDarkMode ? 'fas fa-sun' : 'fas fa-moon'"></i>
          </button>
          
          <!-- Balance - Always visible -->
          <a href="/payouts" class="modern-btn modern-btn-outline mb-0 me-2 me-lg-3 balance-button">
            <i class="fas fa-wallet me-1"></i>
            <span class="d-none d-sm-inline">{{ $store.getters.USERDATA.balance }} USD</span>
            <span class="d-inline d-sm-none">{{ $store.getters.USERDATA.balance }}$</span>
          </a>
          
          <!-- Telegram - Hidden on small mobile -->
          <a href="https://t.me/+7JKA_DC1g_sxMzRi" class="modern-btn modern-btn-primary mb-0 me-2 me-lg-3 d-none d-sm-flex" target="_blank">
            <i class="fab fa-telegram"></i>
            <span class="d-none d-md-inline ms-1">Канал</span>
          </a>
          
          <!-- Exit Button -->
          <button @click="exitApp()" class="modern-btn modern-btn-ghost mb-0 me-2 me-lg-3">
            <i class="fas fa-sign-out-alt"></i>
            <span class="d-none d-md-inline ms-1">Выйти</span>
          </button>
          
        </div>
      </div>
    </nav>
    <!-- End Navbar -->
    
    <!-- Mobile Sidebar Overlay -->
    <div class="sidebar-overlay" @click="closeMobileMenu" :class="{ show: isMobileMenuOpen }"></div>
    
    <!-- Modal - Видео -->
    <div class="modal fade" @click="closeVideo()" id="myModal" tabindex="-1" role="dialog" aria-labelledby="videoModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content glass-card">
          <div class="modal-header">
            <h5 class="modal-title text-gradient" id="videoModalLabel">
              <i class="fas fa-video me-2"></i>Видео инструкция
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="ratio ratio-16x9">
              <iframe ref="video" class="embed-responsive-item" src="" id="video" allowscriptaccess="always" allow="autoplay"></iframe>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="modern-btn modern-btn-outline" data-bs-dismiss="modal">
              <i class="fas fa-times me-1"></i>Закрыть
            </button>
          </div>
        </div>
      </div>
    </div> 
</template>

<script>
import api from '../services/api.js'
import { initPushNotifications } from '../registerServiceWorker.js'

export default {
  name: 'Header',
  data() {
    return {
      videoSrc: 'https://www.youtube.com/watch?v=8iLzkk7l1yU',
      isDarkMode: false,
      isMobileMenuOpen: false,
      pushEnabled: false // Всегда начинаем с false, затем проверяем на сервере
    }
  },
  props: {
    msg: String
  },
  created() {
    // Load theme preference - default to dark mode if not set
    const savedTheme = localStorage.getItem('darkMode')
    this.isDarkMode = savedTheme === null ? true : savedTheme === 'true'
    localStorage.setItem('darkMode', this.isDarkMode)
    this.applyTheme()
  },
  async mounted() {
    // Close mobile menu on resize to desktop
    window.addEventListener('resize', this.handleResize)
    
    // Слушаем изменение пользователя в store
    this.$store.watch(
      (state) => state.user,
      (newUser) => {
        if (newUser && newUser.id) {
          this.checkPushStatus()
        }
      },
      { immediate: true }
    )
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    async checkPushStatus() {
      const user = this.$store.getters.USER
      if (!user || !user.id) return
      
      try {
        const response = await api.get(`/api/push/subscriptions/${user.id}`, {
          headers: { Authorization: user.token }
        })
        
        // Получаем userAgent текущего браузера
        const currentUserAgent = navigator.userAgent
        
        // Фильтруем подписки текущего устройства по userAgent
        const subscriptions = response.data.subscriptions || []
        const currentUserAgentPrefix = currentUserAgent.slice(0, 100)
        
        const currentDeviceSubs = subscriptions.filter(s => 
          s.userAgent && s.userAgent.slice(0, 100) === currentUserAgentPrefix
        )
        
        // Проверяем есть ли активная подписка для текущего устройства
        const hasActive = currentDeviceSubs.some(s => s.active === true)
        
        // Обновляем реактивную переменную
        this.pushEnabled = hasActive
        localStorage.setItem('pushEnabled', hasActive ? 'true' : 'false')
      } catch (e) {
        console.error('Check push status error:', e)
        // При ошибке используем localStorage значение
        const savedStatus = localStorage.getItem('pushEnabled') === 'true'
        this.pushEnabled = savedStatus
      }
    },
    async togglePushNotifications() {
      const user = this.$store.getters.USER
      const userId = user?.id
      
      if (!userId) {
        this.$root.$emit('notify', { type: 'warning', message: 'Сначала войдите в аккаунт' })
        return
      }
      
      if (this.pushEnabled) {
        // Отключаем уведомления
        try {
          // Если PushNotification не инициализирован - загружаем push-client
          const user = this.$store.getters.USER
          if (!window.PushNotification) {
            const script = document.createElement('script')
            script.src = '/push-client.js'
            document.head.appendChild(script)
            await new Promise(resolve => setTimeout(resolve, 1000))
          }
          
          // Инициализируем push-client с userId
          if (window.PushNotification && user && user.id) {
            await window.PushNotification.init(user.id)
          }
          
          // Отписываемся через push-client
          if (window.PushNotification && window.PushNotification.unsubscribe) {
            await window.PushNotification.unsubscribe()
          } else {
            // Если push-client недоступен - отписываемся по userAgent напрямую
            if (user && user.id) {
              await api.post('/api/push/unsubscribe', {
                userId: user.id,
                userAgent: navigator.userAgent
              }, {
                headers: { Authorization: user.token }
              })
            }
          }
          
          // Небольшая задержка чтобы сервер успел обработать
          await new Promise(resolve => setTimeout(resolve, 800))
          
          // Принудительно устанавливаем false
          this.pushEnabled = false
          localStorage.setItem('pushEnabled', 'false')
          
          // Проверяем статус на сервере
          await this.checkPushStatus()
          
          this.$root.$emit('notify', { type: 'info', message: 'Push-уведомления отключены' })
        } catch (e) {
          console.error('Unsubscribe error:', e)
          this.$root.$emit('notify', { type: 'error', message: 'Ошибка при отключении уведомлений' })
        }
      } else {
        // Включаем уведомления
        const success = await initPushNotifications(userId)
        
        if (success) {
          // Проверяем реальный статус на сервере
          await this.checkPushStatus()
          
          if (this.pushEnabled) {
            // Отправляем тестовое уведомление
            setTimeout(async () => {
              if (window.PushNotification) {
                await window.PushNotification.sendTestNotification()
              }
            }, 2000)
            
            this.$root.$emit('notify', { type: 'success', message: 'Push-уведомления включены!' })
          } else {
            this.$root.$emit('notify', { type: 'warning', message: 'Не удалось подписаться на уведомления' })
          }
        } else {
          this.$root.$emit('notify', { type: 'warning', message: 'Push уведомления не поддерживаются или заблокированы' })
        }
      }
    },
    exitApp () {
      localStorage.clear()
      location.href ='/'
    },
    videoPlay () {
      this.$refs.video.src = this.videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0"
    },
    closeVideo () {
      this.$refs.video.src = ''
    },
    toggleTheme () {
      this.isDarkMode = !this.isDarkMode
      localStorage.setItem('darkMode', this.isDarkMode)
      this.applyTheme()
    },
    applyTheme () {
      if (this.isDarkMode) {
        document.body.classList.add('dark-mode')
        document.body.classList.remove('bg-gray-100')
        document.body.classList.add('bg-dark')
      } else {
        document.body.classList.remove('dark-mode')
        document.body.classList.remove('bg-dark')
        document.body.classList.add('bg-gray-100')
      }
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      this.toggleSidebar()
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
      // Close sidebar
      const sidenav = document.querySelector('.sidenav')
      const body = document.querySelector('body')
      if (sidenav) {
        sidenav.classList.remove('g-sidenav-pinned')
        sidenav.classList.remove('g-sidenav-show')
      }
      if (body) {
        body.classList.remove('g-sidenav-pinned')
        body.classList.remove('g-sidenav-show')
      }
    },
    toggleSidebar() {
      const sidenav = document.querySelector('.sidenav')
      const body = document.querySelector('body')
      const iconSidenav = document.getElementById('iconSidenav')
      
      if (sidenav && body) {
        if (body.classList.contains('g-sidenav-pinned')) {
          body.classList.remove('g-sidenav-pinned')
          body.classList.remove('g-sidenav-show')
          sidenav.classList.remove('g-sidenav-pinned')
          sidenav.classList.remove('g-sidenav-show')
          if (iconSidenav) {
            iconSidenav.classList.remove('d-none')
          }
        } else {
          body.classList.add('g-sidenav-pinned')
          body.classList.add('g-sidenav-show')
          sidenav.classList.add('g-sidenav-pinned')
          sidenav.classList.add('g-sidenav-show')
          if (iconSidenav) {
            iconSidenav.classList.add('d-none')
          }
        }
      }
    },
    handleResize() {
      if (window.innerWidth >= 992) {
        this.isMobileMenuOpen = false
      }
    }
  }
}
</script>

<style scoped>
.router-link-exact-active {
  background-color: #0d47a1;
  cursor: pointer;
}

/* ===== MOBILE MENU BUTTON ===== */
.navbar-toggler {
  padding: 0.5rem 0.75rem !important;
  border: 1px solid var(--modern-bg-tertiary) !important;
  border-radius: 0.5rem !important;
  background: rgba(99, 102, 241, 0.1) !important;
  transition: all 0.2s ease !important;
}

.navbar-toggler:hover {
  background: rgba(99, 102, 241, 0.2) !important;
  transform: scale(1.05);
}

.navbar-toggler:active {
  transform: scale(0.95);
}

.navbar-toggler:focus {
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2) !important;
  outline: none !important;
}

.navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='%236366f1' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
  width: 1.25em !important;
  height: 1.25em !important;
}

/* Dark theme navbar-toggler */
body.dark-mode .navbar-toggler {
  border-color: rgba(255, 255, 255, 0.1) !important;
  background: rgba(99, 102, 241, 0.15) !important;
}

body.dark-mode .navbar-toggler:hover {
  background: rgba(99, 102, 241, 0.25) !important;
}

body.dark-mode .navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='%23818cf8' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
}

/* ===== MOBILE SIDEBAR OVERLAY ===== */
.sidebar-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  opacity: 0;
  transition: opacity 0.3s ease;
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
}

.sidebar-overlay.show {
  display: block;
  opacity: 1;
}

/* ===== MOBILE TITLE ===== */
.mobile-only {
  display: none !important;
}

@media (max-width: 991.98px) {
  .mobile-only {
    display: block !important;
  }
  
  .desktop-only {
    display: none !important;
  }
}

/* ===== THEME TOGGLE BUTTON ===== */
.theme-toggle {
  width: 40px !important;
  height: 40px !important;
  padding: 0.5rem !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: all 0.2s ease !important;
}

.theme-toggle:hover {
  background: rgba(99, 102, 241, 0.1) !important;
  transform: rotate(15deg);
}

.theme-toggle:active {
  transform: scale(0.9);
}

/* ===== NAVBAR LINKS ===== */
#iconNavbarSidenav {
  min-width: 44px !important;
  min-height: 44px !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 0.5rem !important;
  transition: all 0.2s ease !important;
}

#iconNavbarSidenav:hover {
  background: rgba(99, 102, 241, 0.1) !important;
  transform: rotate(90deg);
}

.sidenav-toggler-inner {
  position: relative;
  width: 20px;
  height: 14px;
}

.sidenav-toggler-line {
  display: block;
  width: 100%;
  height: 2px;
  background: var(--modern-text-secondary);
  border-radius: 1px;
  transition: all 0.2s ease;
}

.sidenav-toggler-line:nth-child(1) {
  margin-bottom: 4px;
}

.sidenav-toggler-line:nth-child(2) {
  margin-bottom: 4px;
}

#iconNavbarSidenav:hover .sidenav-toggler-line {
  background: var(--modern-primary);
}

/* Dark theme sidenav toggler */
body.dark-mode .sidenav-toggler-line {
  background: #94a3b8;
}

body.dark-mode #iconNavbarSidenav:hover .sidenav-toggler-line {
  background: #818cf8;
}

/* ===== PUSH NOTIFICATIONS BUTTON ===== */
.push-enabled {
  background: rgba(16, 185, 129, 0.2) !important;
  color: #10b981 !important;
}

.push-enabled:hover {
  background: rgba(16, 185, 129, 0.3) !important;
}

body.dark-mode .push-enabled {
  background: rgba(16, 185, 129, 0.25) !important;
}

/* Push disabled state */
.push-enabled i {
  animation: bell-ring 2s ease-in-out infinite;
}

@keyframes bell-ring {
  0%, 100% {
    transform: rotate(0);
  }
  10%, 30% {
    transform: rotate(10deg);
  }
  20%, 40% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(0);
  }
}

body.dark-mode .theme-toggle:not(.push-enabled) {
  color: #94a3b8 !important;
}

body.dark-mode .theme-toggle:not(.push-enabled):hover {
  background: rgba(255, 255, 255, 0.1) !important;
}
</style>